import {
    ComponentSettingsChartDataQueriesTable,
    ComponentSettingsManageFiltersDataQueries,
    RendererFilter,
} from '@report-content';

export default function buildDataQueries(fields: RendererFilter[]) {
    let dataQueries: ComponentSettingsManageFiltersDataQueries = { skip: true };
    fields
        .filter((field) => field.filter_column == 'Y')
        .forEach((field) => {
            if ('dropdown' == field.filterType || 'multiselect' == field.filterType) {
                let dq: ComponentSettingsChartDataQueriesTable = {
                    resultFields: [field.reference_name],
                    sort: [{ field: field.reference_name, dir: 'DESC' === field.sortDirection ? 'DESC' : 'ASC' }],
                    resultFieldAggregations: {},
                    distinct: true,
                };

                if ('Y' == field?.use_external_filter_value) {
                    dq['isExternalFilter'] = true;
                }

                dataQueries[field.reference_name] = dq;
            } else if ('range' == field.filterType || 'charting_interval' == field.filterType) {
                const rfaMin: any = {};
                const rfaMax: any = {};
                rfaMin[field.reference_name] = 'Min';
                dataQueries[`${field.reference_name}-from`] = {
                    resultFields: [field.reference_name],
                    resultFieldAggregations: rfaMin,
                };
                rfaMax[field.reference_name] = 'Max';
                dataQueries[`${field.reference_name}-to`] = {
                    resultFields: [field.reference_name],
                    resultFieldAggregations: rfaMax,
                };
            }
        });
    return dataQueries;
}
